/**
 * Copyright (c) S2 Partnership Ltd. 2025
 *
 * Controller for the sync-modal dialog window that displays when syncing is in process.
 *
 * @summary Controller for html-modal dialog window.
 * @author S2 Partnership Ltd
 *
 * Created at     : 15-12-2025
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ProcessingOverlayService } from 'src/app/modules/app/providers/processing-overlay.service';

@Component({
    selector: 'app-sync-modal',
    templateUrl: 'sync-modal.component.html',
    styleUrls: ['./sync-modal.component.scss']
})

export class SyncModalComponent implements OnInit, OnDestroy {
    syncMessage = '';
    private messageSubscription: Subscription;
    private canCancelSubscription: Subscription;
    showCancel = false;
    modalDismiss: string;

    /**
     * Standard Angular Constructor
     *
     * @ignore
     */
    constructor(
    /* eslint-disable */
    private modalController: ModalController,
    private processingOverlayService: ProcessingOverlayService,
    /* eslint-enable */
    ) {
        // Empty constructor.
    }

    /**
     * Invoked when this view is created.
     */
    ngOnInit(): void {
        // Subscribe to messages as soon as the component initializes
        this.messageSubscription = this.processingOverlayService.currentMessage$.subscribe(message => {
          this.syncMessage = message;
        });

        this.canCancelSubscription = this.processingOverlayService.currentCanCancelSync$.subscribe(canCancelSync => {
            this.showCancel = canCancelSync;
        });
    }

    /**
     * Invoked when this view is destroyed.
     */
    ngOnDestroy(): void {
      if (this.messageSubscription) {
        this.messageSubscription.unsubscribe();
      }
      if (this.canCancelSubscription) {
        this.canCancelSubscription.unsubscribe();
      }
    }

    /**
     * Callback method for the continue button being pressed on the modal view.
     *
     * @returns {any} A dismiss event will be broadcast.
     */
    dismiss(): any {
      return this.modalController.dismiss(null, 'dismiss');
    }

}
